export default "__VITE_ASSET__CUg$890u__"